__turbopack_context__.v({
  "copyComboNotification": "copyComboLinkButton-module-scss-module__YC4m0a__copyComboNotification",
  "hiddenComboLinkInput": "copyComboLinkButton-module-scss-module__YC4m0a__hiddenComboLinkInput",
  "show": "copyComboLinkButton-module-scss-module__YC4m0a__show",
});
